module.exports = __webpack_public_path__ + "img/icon-logout.83012576.svg";